import { variant } from 'styled-system';

export const segmentModeVariants = variant({
  scale: 'RouteBarMode',
  variants: {
    air: {
      backgroundColor: '#BFDB9C',
      '&:hover': {
        backgroundColor: 'transport.plane',
      },
      svg: {
        fill: 'white',
      },
      '.mode-icon': {
        backgroundColor: 'transport.plane',
      },
    },
    water: {
      backgroundColor: '#84D4EC',
      '&:hover': {
        backgroundColor: 'transport.ship',
      },
      svg: {
        fill: 'white',
      },
      '.mode-icon': {
        backgroundColor: 'transport.ship',
      },
    },
    rail: {
      backgroundColor: '#F9C89A',
      '&:hover': {
        backgroundColor: 'transport.rail',
      },
      svg: {
        fill: 'white',
      },
      '.mode-icon': {
        backgroundColor: 'transport.rail',
      },
    },
    road: {
      backgroundColor: '#e2e2e2',
      '&:hover': {
        backgroundColor: '#aeaeae',
      },
      svg: {
        fill: 'white',
      },
      '.mode-icon': {
        backgroundColor: '#aeaeae',
      },
    },
  },
});
